export default	{
	data: {
		'stat-home':{},
		'camera':{"results":[]},
		'order':{"results":[]},
		'order_method_type':{"results":[]},
		'order_object_type':{"results":[]},
		'settings-tax':{
			normominute_price: 0,
			tax_percent: 0,
			tax_min: 0,
			average_price: 0
		},
		'static': {
			results: []
		},
		'photo': {
			results: []
		},
		'settings': {},
	},

	orderObjectById: {
		data: {}
	},

	// session & currentUser razdelit na razniye objects
	session: {
		isLoggedIn: false,
		isFetching: false,
		currentUser: {},
		errorMessage: ''
	},

	register: {
		isFetching: false,
		errorMessage: '',
		data: {}
	},

	orders: {
		data: {
			results:[]
		},
		isFetching: false,
		errorMessage: '',

		orderById: {
			data: {},
		//	isFetching: false,
			errorMessage: '',

			executorById: {
				data: {
					results: [],
				},
				isFetching: false,
				errorMessage: '',
			}
		},
	},

	camera_requirement: {
		data: {}
	},

	objectTypes: {
		data: {}
	},

	methodTypes: {
		data: {}
	},

	measures: {
		data: {}
	},

	makeOrders: {
		dataBidUser: {
			results:[]
		}
	},

	locations: {
		data: {},
	},

	company: {
		companies: {
			data: {
				results:[]
			},
			isFetching: false,
			errorMessage: ''
		},

		invoices: {
			data: {
				results:[]
			},
			isFetching: false,
			errorMessage: ''
		},

		transactions: {
			data: {
				results:[]
			},
			isFetching: false,
			errorMessage: ''
		},

		orders: {
			data: {
				results:[]
			},
			isFetching: false,
			errorMessage: ''
		},
	},

	employees: {
		data: {
			results:[]
		},
		admins: {
			results: [],
			isFetching: false,
		},
		isFetching: false,
		errorMessage: ''
	},

	equipments: {
		data: {
			results: []
		},
		isFetching: false,
		errorMessage: ''
	},

	transactions: {
		data: {
			results: []
		},
		isFetching: false,
		errorMessage: ''
	},

	news: {
		data: {
			results: []
		},
		isFetching: false,
		errorMessage: ''
	},

	//payOutTransaction
	payOut: {
		data: {
			results: []
		},
		isFetching: false,
		errorMessage: ''
	},

	promocode: {
		data: {},
		isFetching: false,
		errorMessages: ''
	},

	// Можем изменить в будущем, поэтому использовать [this.props.auth] не рекомендуется
	auth: {
		isFetching: false,
		isAuthenticated: localStorage.getItem('id_token') ? true : false
	},

	products: {
		data: {
			results: []
		},
		isFetching: false,
		errors: ""
	},
	
	isLoading: true
}


// WEBPACK FOOTER //
// ./src/reducers/initialState.js